import React, { createContext, useReducer, useState, useEffect } from "react";

export const ThemeContext = createContext();

const THEMED = "THEMED";

const initialState = {
  theme: JSON.parse(localStorage.getItem("theme")),
};

const reducer = (state, action) => {
  switch (action.type) {
    case THEMED:
      return {
        ...state,
        theme: action.payload,
      };

    default:
      return state;
  }
};

export const ThemeProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const [theme, setTheme] = useState(localStorage.getItem("theme") ?? false);
  localStorage.setItem("theme", theme);

  let store = JSON.parse(theme);
  
  const ChangeTheme = () => {
    dispatch({ type: THEMED, payload: store });
  };

  useEffect(() => {
    ChangeTheme();

    // eslint-disable-next-line
  }, [theme]);

  return (
    <ThemeContext.Provider
      value={{
        theme: state.theme,
        setTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
